const photoModules = import.meta.glob('./img-*.jpg', { eager: true, import: 'default' }) as Record<string, string>;
import floorplan3d from './img-3.jpg';
import floorplan2d from './img-12.jpg';

const floorPlanFiles = new Set(['./img-3.jpg', './img-12.jpg']);

const sorted = Object.entries(photoModules)
  .filter(([path]) => !floorPlanFiles.has(path))
  .sort(([a], [b]) => {
    const na = parseInt(a.match(/img-(\d+)/)?.[1] || "0");
    const nb = parseInt(b.match(/img-(\d+)/)?.[1] || "0");
    return na - nb;
  })
  .map(([, src]) => src);

export const uhrineves2Images: string[] = sorted;

export const uhrineves2FloorPlans = [
  { image: floorplan3d, label: "Půdorys bytu – 3D" },
  { image: floorplan2d, label: "Půdorys bytu – 2D" },
];
